<template>
    <div>
        <home></home>
        <patient-list></patient-list>
    </div>
</template>

<script>
import Home from "@/views/home";
import PatientList from "@/components/PatientList";

export default {
    components: {Home, PatientList}
}
</script>

<style scoped>

</style>
